<script setup lang="ts">
import type { Picture } from "~/layers/ui/components/image/Picture";

interface props {
  content: {
    id: number;
    __component: string;
    title: string;
    subtitle: string;
    cover: Picture;
    webhook?: string;
    anchorId?: string | null;
  };
  projects: { label: string }[];
}

const props = withDefaults(defineProps<props>(), {
  content: {
    id: 1,
    __component: "",
    title: "Форма уведомления",
    subtitle: "Оставьте заявку",
  },
});

const getCover = computed(() => {
  return props.content?.cover?.data?.attributes?.url ?? "/img/1.webp";
});
</script>

<template>
  <section
    :id="content?.anchorId || undefined"
    ref="section"
    class="py-20 lg:py-[6.25rem] bg-primary-foreground scroll-mt-24"
  >
    <Container>
      <Text class="font-medium text-primary/60 mb-3" variant="12">{{ content.subtitle }}</Text>
      <Heading class="leading-[100%] mb-14" as="h2" variant="4" text-transform="uppercase">{{ content.title }}</Heading>
      <div class="grid lg:grid-cols-2 gap-[1.88rem]">
        <NotificationForm :projects="projects" :webhook="content.webhook" show-comment />
        <template v-if="getCover">
          <img
            v-if="getCover"
            class="object-cover w-full max-lg:hidden lg:h-[32rem] rounded-md"
            loading="lazy"
            :src="getCover"
            :alt="content.title"
          />
        </template>
      </div>
    </Container>
  </section>
</template>

<style scoped></style>
